import classNames from 'classnames';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, } from 'react';
import { playVideo } from '../../../../call/helpers';
export const ParticipantVideo = forwardRef(({ className, active, participant, onPlay = () => { }, onPause = () => { } }, ref) => {
    const internalRef = useRef();
    const play = () => {
        let canceled = false;
        if (!participant.videoElementPromise) {
            pause();
            return;
        }
        participant.videoElementPromise.then(async ({ srcObject }) => {
            if (canceled) {
                return;
            }
            if (internalRef.current.srcObject !== srcObject) {
                internalRef.current.srcObject = srcObject;
            }
            await playVideo(internalRef.current);
            if (canceled) {
                return;
            }
            onPlay(participant);
        });
        return () => {
            canceled = true;
        };
    };
    const pause = async () => {
        if (!internalRef.current.paused) {
            internalRef.current.pause();
        }
        onPause(participant);
    };
    useImperativeHandle(ref, () => ({
        play,
        pause,
    }), [play]);
    useEffect(() => {
        if (active) {
            return play();
        }
        pause();
    }, [active]);
    useEffect(() => {
        return play();
    }, [participant.videoElementPromise]);
    return (<video className={classNames(className, { hidden: !active })} muted playsInline autoPlay ref={internalRef}/>);
});
